var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"animated fadeIn background"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isAuthenticaded)?_c('toolbar'):_vm._e()],1),_c('v-main',[_c('transition',{attrs:{"name":"fade"}},[_c('div',[(_vm.isAuthenticaded)?_c('navigation'):_vm._e(),_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }